import { PayPalSftpFilesState } from "./paypal-sftp-files.state";
import { ActionTypes } from "./paypal-sftp-files.actions";

export const PayPalSftpFilesReducer = (
    state: PayPalSftpFilesState = new PayPalSftpFilesState(),
    action: any,
  ): PayPalSftpFilesState => {

    switch (action.type) {

        case ActionTypes.GetPayPalSftpFiles: {
            return {
                ...state,
                loading: true
            };
        }

        case ActionTypes.GetPayPalSftpFilesSucceed: {
            const morePagesMode = (action.response.totalPages == null);
            return {
                ...state,
                record: action.response.items,
                pager: {
                    pageSize: action.pageSize,
                    page: action.page,
                    pageCount: morePagesMode ? action.response.morePages : action.response.totalPages,
                    morePagesMode
                },
                loading: false,
                error: null,
                ...action.stateExtensions
            };
        }

        case ActionTypes.GetPayPalSftpFilesFail: {
            return {
                ...state,
                record: [],
                loading: false,
                error: action.error
            };
        }

        case ActionTypes.SortPayPalSftpFiles: {
            return {
                ...state,
                loading: true,
                sorting: action.sorting
            };
        }

        case ActionTypes.FilterPayPalSftpFiles: {
            return {
                ...state,
                loading: true,
                filter: action.filter
            };
        }

        default: {
            return state;
        }
    }

};
